import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/on demand apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const OnDemandApps = () => {
  const heroData = {
    title: "On-Demand Service Platform Development",
    description: "Create powerful on-demand platforms that connect customers with services instantly. We build scalable, real-time solutions for ride-sharing, delivery, healthcare, and service marketplaces.",
    image: img13,
    imageAlt: "On-Demand Apps",
    features: [
      "Real-time tracking",
      "Geolocation services",
      "Dynamic pricing",
      "Multi-sided platforms",
      "Payment processing",
      "Provider management",
    ],
    pillars: [
      "Real-time connectivity that enables instant service delivery",
      "Intelligent matching algorithms that optimize service quality",
      "Scalable infrastructure that grows with demand and geography",
    ],
  };

  const journeySteps = [
    {
      title: "Market Research & Strategy",
      description: "We analyze your target market, competitive landscape, and service model to design the optimal on-demand platform architecture.",
      details: ["Market analysis", "Business model", "Competitor research", "Pricing strategy", "Service categories", "Target demographics"],
    },
    {
      title: "Multi-Sided Platform Design",
      description: "Our team designs seamless experiences for all stakeholders—customers, service providers, and administrators—with intuitive interfaces.",
      details: ["Customer UX", "Provider interface", "Admin dashboard", "Matching algorithms", "Rating systems", "Communication flows"],
    },
    {
      title: "Development & Integration",
      description: "We build scalable platforms with real-time features, geolocation services, payment processing, and provider management systems.",
      details: ["Real-time development", "GPS integration", "Payment gateways", "Push notifications", "Provider onboarding", "API integrations"],
    },
    {
      title: "Launch & Scaling",
      description: "From beta testing to full launch, we ensure your platform handles growth with monitoring, optimization, and feature enhancements.",
      details: ["Beta testing", "Market launch", "Geographic expansion", "Performance optimization", "Feature rollout", "Analytics setup"],
    },
  ];

  const capabilities = [
    {
      title: "Ride-Sharing Apps",
      content:
        "Uber-like transportation platforms with real-time tracking, dynamic pricing, driver matching, and route optimization.",
    },
    {
      title: "Food Delivery",
      content:
        "Complete food delivery solutions with restaurant management, order tracking, delivery optimization, and payment systems.",
    },
    {
      title: "Service Marketplaces",
      content:
        "On-demand service platforms connecting customers with professionals for home services, beauty, wellness, and more.",
    },
    {
      title: "Healthcare Apps",
      content:
        "Telemedicine and on-demand healthcare platforms with doctor matching, appointment scheduling, and consultation features.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "100K+", label: "Active users (first year)" },
      { value: "95%", label: "Service completion rate" },
      { value: "<3min", label: "Average matching time" },
    ],
    description: "We deliver on-demand platforms that achieve rapid user adoption, high service completion rates, and strong marketplace growth.",
  };

  const outcomesData = {
    description: "We create on-demand platforms that connect customers with services seamlessly, enabling efficient marketplaces and exceptional user experiences for all stakeholders.",
    outcomes: [
      "Real-time GPS tracking and geolocation services",
      "Dynamic pricing and surge pricing algorithms",
      "Multi-sided platform (customer, provider, admin)",
      "Payment gateway and wallet integration",
      "Rating and review systems",
      "Push notifications and real-time updates",
    ],
  };

  const whyChooseUs = [
    {
      title: "Real-Time Technology",
      content:
        "We build platforms with live tracking, instant notifications, and real-time updates for seamless on-demand experiences.",
    },
    {
      title: "Scalable Architecture",
      content:
        "Infrastructure designed to handle rapid growth, peak demand, and geographic expansion without performance issues.",
    },
    {
      title: "Multi-Stakeholder Focus",
      content:
        "Balanced experiences for customers, service providers, and admins with dedicated apps and management tools.",
    },
    {
      title: "Proven Business Models",
      content:
        "Implementation of tested monetization strategies including commissions, subscriptions, and dynamic pricing.",
    },
  ];

  const faqs = [
    {
      q: "How long does it take to build an on-demand app like Uber?",
      a: "A basic MVP with core features takes 4-6 months, while a full-featured platform with advanced capabilities may take 8-12 months. Timeline depends on complexity, features, and platform (iOS, Android, or both).",
    },
    {
      q: "What's the cost to develop an on-demand service platform?",
      a: "Development costs range from $60K for a basic MVP to $250K+ for a comprehensive multi-sided platform with real-time features, payment processing, and advanced matching algorithms.",
    },
    {
      q: "Do you provide separate apps for customers and service providers?",
      a: "Yes! We develop dedicated apps for customers, service providers, and an admin dashboard for platform management, each optimized for their specific needs and workflows.",
    },
    {
      q: "How do you implement dynamic pricing and surge pricing?",
      a: "We develop intelligent algorithms that adjust pricing based on demand, time, location, and supply availability, similar to Uber's surge pricing, ensuring optimal marketplace balance and revenue.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"On-Demand App Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our On-Demand Platform Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default OnDemandApps;
